import React, { useEffect, useState } from "react"
import MapGL, { Marker, NavigationControl, Popup } from "react-map-gl/mapbox"
import MyLocationImg from "../../../images/map/location.png"
import { Image } from "semantic-ui-react"
import MapControlContainer from "../../../v1/CarAdvise2/screens/Map/components/MapControlContainer"
import {
  DEFAULT_LATITUDE,
  DEFAULT_LONGITUDE,
  DEFAULT_MAP_HEIGHT,
  DEFAULT_MAP_WIDTH,
  DEFAULT_ZOOM,
  MAP_STYLE
} from "../../../v1/constants/mapbox"
import { useTranslation } from "react-i18next"
import { ProgressHUDMap } from "../../../v1/CarAdvise2/screens/components/ProgressHUD"
import Geosuggest from "react-geosuggest"
import { suggestGeoSuggestClick } from "../../../v1/CarAdvise2/helpers/geoLocationHelper"
import { connect } from "react-redux"
import EmptyShopLogo from "../../../images/empty_shop_logo.svg"
import SponsoredShopLogo from "../../../images/dashboard/check-icon.svg"
import CloseLogo from "../../../images/close-icon.svg"
import { isEmpty } from "lodash"
import { isMobile } from "react-device-detect"
import ReactSVG from "react-svg"
import openInGoogleMaps from "../../../v1/helpers/mapBoxHelpers"
import "../../../css/mapbox-gl.css"

const MapBox = ({
  shops,
  recenterClick,
  expandCompressClick,
  containerClassName,
  isExpanded,
  isLoading = false,
  showSearch = true,
  user,
  onSuggestSelect,
  searchLocation,
  handleIconClick,
  selectedItem,
  mapSelectComponent,
  isShopSelection = false
}) => {
  const { t } = useTranslation("fuelStation")

  const [viewport, setViewport] = useState({
    latitude: DEFAULT_LATITUDE,
    longitude: DEFAULT_LONGITUDE,
    zoom: DEFAULT_ZOOM,
    width: DEFAULT_MAP_WIDTH,
    height: DEFAULT_MAP_HEIGHT
  })

  const [openPopup, setOpenPopup] = useState(false)

  const handlePopup = () => {
    setOpenPopup((prev) => !prev)
  }

  useEffect(() => {
    if (shops && shops.length > 0) {
      setViewport((prev) => {
        return {
          ...prev,
          latitude: shops[0].lat || DEFAULT_LATITUDE,
          longitude: shops[0].lng || DEFAULT_LONGITUDE
        }
      })
    } else if (searchLocation) {
      setViewport((prev) => {
        return {
          ...prev,
          latitude: searchLocation?.lat || DEFAULT_LATITUDE,
          longitude: searchLocation?.lng || DEFAULT_LONGITUDE
        }
      })
    }
  }, [shops, searchLocation])

  const handleRecenterClick = (shop) => {
    if (recenterClick) {
      recenterClick()
    } else {
      setViewport((prev) => {
        return {
          ...prev,
          zoom: DEFAULT_ZOOM,
          latitude: shop?.lat || shops?.[0]?.lat || DEFAULT_LATITUDE,
          longitude: shop?.lng || shops?.[0]?.lng || DEFAULT_LONGITUDE
        }
      })
    }
  }

  return (
    <div className={`map-container ${containerClassName}`}>
      {/* Search bar */}
      {showSearch && (
        <Geosuggest
          onSuggestSelect={(suggest) => suggestGeoSuggestClick(suggest, onSuggestSelect)}
          placeholder={t("mapSearchInputPlaceholder")}
          types={["geocode"]}
          country={user.country}
          ignoreTab={true}
          className="geosuggestContainerNew"
          suggestsClassName="search-suggests-list"
          suggestItemClassName="search-suggest-item"
          inputClassName={`searchFldShop smaller-width`}
          suggestItemActiveClassName="search-suggest-item-active"
          suggestsHiddenClassName="search-suggests-list-hidden"
          fixtures={[{ label: t("use-current-location"), custom: true }]}
        />
      )}
      {/* Map container */}
      <MapGL
        {...viewport}
        mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
        onMove={(evt) =>
          setViewport({ ...evt.viewState, width: DEFAULT_MAP_WIDTH, height: DEFAULT_MAP_HEIGHT })
        }
        attributionControl={false}
        style={{ borderRadius: "10px" }}
        mapStyle="mapbox://styles/mapbox/streets-v9"
      >
        {/* Marker for user's current location */}
        {searchLocation &&
          searchLocation.lat &&
          searchLocation.lng &&
          searchLocation.isUserCurrentLocation && (
            <Marker latitude={searchLocation.lat} longitude={searchLocation.lng}>
              <Image
                style={{ maxWidth: "30px" }}
                src={MyLocationImg}
                className="current-position-image"
              />
            </Marker>
          )}

        {/* Markers for shops */}
        {isShopSelection &&
          (shops || []).map((shop) => {
            const { lat, id, lng, logo_url } = shop
            const isSelectedShop = selectedItem && selectedItem.id === shop.id

            return (
              <Marker key={id} latitude={lat} longitude={lng}>
                <Image
                  src={isSelectedShop ? SponsoredShopLogo : logo_url || EmptyShopLogo}
                  className={`shop-icon ${isSelectedShop ? "selected-item-map" : ""} `}
                  onClick={() => {
                    handleIconClick(shop)
                    handlePopup()
                  }}
                />
              </Marker>
            )
          })}

        {!isEmpty(selectedItem) ? (
          isMobile ? (
            <div className="mobile-popup">
              <ReactSVG
                className="map-tile-cross-logo"
                src={CloseLogo}
                onClick={() => handleIconClick({})}
              />
              {mapSelectComponent}
            </div>
          ) : (
            <Popup
              className="onTop"
              latitude={selectedItem.lat}
              longitude={selectedItem.lng}
              closeOnClick={false}
              closeButton={false}
              anchor="top"
              style={{ padding: "10px 10px 6px" }}
              onClose={() => {
                handleIconClick({})
                handlePopup()
              }}
              open={openPopup}
            >
              <ReactSVG
                className="map-tile-cross-logo"
                src={CloseLogo}
                onClick={() => {
                  handleIconClick({})
                  handlePopup()
                }}
              />
              {mapSelectComponent}
            </Popup>
          )
        ) : null}
        {!isShopSelection &&
          (shops || []).map((shop) => (
            <Marker key={shop.id} latitude={shop.lat} longitude={shop.lng}>
              <div className="map-marker-bg-image">
                <Image
                  src={shop.logo_url || EmptyShopLogo}
                  className="markerLogoStyling mapMarkerBG marker-shop-logo"
                  onClick={() => openInGoogleMaps(shop.lat, shop.lng, shop.site_name)}
                />
              </div>
            </Marker>
          ))}

        {isLoading && (
          <div className="map-loader">
            <ProgressHUDMap />
          </div>
        )}

        {/* Navigation controls */}
        <div className="action-controller">
          <MapControlContainer
            isExpanded={isExpanded}
            expandCompressClick={expandCompressClick}
            recenterClick={() => handleRecenterClick(selectedItem)}
          />
        </div>
        <NavigationControl className="navigation-icon" position="bottom-right" />
      </MapGL>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(MapBox)
